'use client';
module.exports = require('../dist/components/Tooltip/Tooltip');
